import { render } from "./MigrationV5Modal.vue?vue&type=template&id=67e9404d&scoped=true"
import script from "./MigrationV5Modal.vue?vue&type=script&lang=ts"
export * from "./MigrationV5Modal.vue?vue&type=script&lang=ts"

import "./MigrationV5Modal.vue?vue&type=style&index=0&id=67e9404d&lang=scss&scoped=true"
import "./MigrationV5Modal.vue?vue&type=style&index=1&id=67e9404d&lang=scss"
script.render = render
script.__scopeId = "data-v-67e9404d"

export default script